import state from './rollBookState';
import mutations from './rollBookMutations';
import getters from './rollBookGetters';
import actions from './rollBookActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
